import React, { useState } from 'react';

import DataState from '../loading/DataState';

/**
 * DataState for a chart's regions (KPR-647), with one addition the primitive
 * does not make: a **Retry** starts the wait's clock again.
 *
 * A chart's numbers come from one batch request that cannot be cancelled, so
 * after the 30 s error a Retry may find the same request still out. Without a
 * fresh clock the region would sit on the error and look dead. Remounting the
 * DataState on each Retry restarts the 150 ms / 3 s / 30 s timings from the
 * press, so the person sees the skeleton and the hint again, not a frozen
 * error. The caller's `onRetry` still does the asking.
 */
export default function RetryDataState({ onRetry, ...props }) {
	const [attempt, setAttempt] = useState(0);
	const retry = typeof onRetry === 'function'
		? () => {
			setAttempt((n) => n + 1);
			onRetry();
		}
		: undefined;
	return <DataState key={attempt} {...props} onRetry={retry} />;
}
